import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getAuthToken = () => localStorage.getItem('token');

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getAuthToken()}`,
  },
});

// CRM-managed email templates. Unlike SMS templates, the body is NOT stored
// here — each row points at a Brevo transactional template (brevo_template_id)
// that owns the HTML, branding and signature.

// Pass includeInactive when building the management screen; the composer
// should only ever offer active templates.
export const getEmailTemplates = async ({ category = null, includeInactive = false } = {}) => {
  try {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (includeInactive) params.append('includeInactive', 'true');
    const qs = params.toString() ? `?${params.toString()}` : '';
    const response = await axios.get(`${API_URL}/email-templates${qs}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching email templates:', error);
    throw error;
  }
};

export const getEmailTemplate = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/email-templates/${id}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching email template:', error);
    throw error;
  }
};

export const createEmailTemplate = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/email-templates`, data, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error creating email template:', error);
    throw error;
  }
};

export const updateEmailTemplate = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}/email-templates/${id}`, data, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error updating email template:', error);
    throw error;
  }
};

export const deleteEmailTemplate = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/email-templates/${id}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error deleting email template:', error);
    throw error;
  }
};
